export const EXTERNAL_REDIRECT_URL_KEY = "external_redirect_url";
export const INTERNAL_REDIRECT_URL_KEY = "internal_redirect_url";
export const PREFERRED_LOGIN_METHOD_KEY = "preferred_login_method";
export const WORKNEST_TOKEN_KEY = "worknest_token";
export const WORKNEST_TOKEN_USER_DETAIL = "worknest_token_user_detail";

export const IMPERSONATION_ID_KEY = "impersonation-id";
export const IMPERSONATION_TOKEN_KEY = "impersonation-token";